module.exports = __webpack_public_path__ + "static/test-hexarch-354014b0a59cb9f2a35b9130e09c7c76.png";